<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-list mr-2" />Daftar Transaksi</h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="Dari Tanggal">
                        <b-input type="date" v-model="filter.startDate" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Sampai Tanggal">
                        <b-input type="date" v-model="filter.endDate" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Customer">
                        <multiselect v-model="filter.customer"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optCustomer"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                        <b-button variant="primary" class="ml-2 btn-dark" @click="downloadLaporanPoin()">
                            <i class="fa fa-download mr-2" />Download
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="my-3"
            >
                <template v-slot:empty>
                    Tidak ada data transaksi.
                </template>
                <template v-slot:cell(customer)="row">
                    {{ row.item.customer ? row.item.customer.name : "-" }} ({{ row.item.customer && row.item.customer.cities ? row.item.customer.cities.name : "-" }})
                </template>
                <template v-slot:cell(faktur)="row">
                    {{ row.item.no_faktur }}
                </template>
                <template v-slot:cell(transaction_at)="row">
                    {{ $helper.parseDate(row.item.transaction_at) }}
                    <div class="small text-muted">
                        {{ row.item.transaction_by ? row.item.transaction_by.fullname : "-" }}
                    </div>
                </template>
                <template v-slot:cell(added)="row">
                    {{ row.item.point_added }}
                </template>
                <template v-slot:cell(current)="row">
                    {{ row.item.current_point }}
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-download" title="Laporan Poin Customer" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="status == 0">
                Menyiapkan file Excel, mohon menunggu...
            </div>
            <div v-else-if="status == -1">
                Gagal menyiapkan file Excel.
            </div>
            <div v-else>
                File Excel sudah siap. Tekan tombol dibawah ini untuk download file Excel.
                <div class="mt-2">
                    <a :href="$BASE_FILE_PATH + path" download>
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" />Download Laporan Poin Customer
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            successData: {},

            filter: {
                type: -1,
                customer: null,
                startDate: "",
                endDate: ""
            },

            input: {
                customer: null,
                payment: "",
                note: ""
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "customer", label: "Customer", sortable: true },
                { key: "faktur", label: "No. Faktur", sortable: true },
                { key: "transaction_at", label: "Transaksi pada / oleh", sortable: true },
                { key: "added", label: "Poin Ditambahkan / Dikurangkan", sortable: true },
                { key: "current", label: "Jumlah Poin Customer", sortable: true }
            ],

            items: [],
            activeItem: {},

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optCustomer: [],
            optCustomerForTransaction: [],

            status: 0,

        }
    },
    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getCustomers = this.$axios.get("customer/selection").then(res => {
                this.optCustomer = res.data.data
            })

            Promise.all([getItems, getCustomers]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(this.filter.type != -1) {
                param += "&filterType=" + this.filter.type
            }

            if(!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if(!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            if(this.filter.customer != null) {
                param += "&filterCustomer=" + this.filter.customer.id
            }

            if(this.sortBy != null) {
                param += "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("point" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listPointTransactionFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        downloadLaporanPoin() {

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("point/download-point-report").then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
            .catch(error => {
                this.status = -1
                this.$helper.parseError(this, error)
            })
        },

    },
    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listPointTransactionFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listPointTransactionFilter"))
        }
        this.init()
    }
}
</script>

<style>

</style>
